import { queryOptions, useMutation, useQuery, useQueryClient, useSuspenseQuery } from "@tanstack/react-query"
import { completeInductionStep, getAuthenticationMethods, getInductionProgress, startInduction } from "./api"
import { useHostMode } from "@stores/usePortalModeStore"
import { useStaffOverrideStore } from "@stores/useStaffOverrideStore"

export const authenticationMethodsQueryOptions = () =>
    queryOptions({
        queryKey: ['authenticationMethods'],
        queryFn: () => getAuthenticationMethods(),
    })

export function useAuthenticationMethods() {
    return useQuery(authenticationMethodsQueryOptions())
}

export function useAuthenticationMethodsSuspense() {
    return useSuspenseQuery(authenticationMethodsQueryOptions())
}

export const inductionProgressQueryOptions = (identityKey: string, enabled = true) => queryOptions({
    queryKey: ['inductionProgress', identityKey],
    queryFn: getInductionProgress,
    enabled,
})

export function useInductionProgress(enabled = true) {
    const hostMode = useHostMode()
    const override = useStaffOverrideStore((state) => state.override?.trim() ?? '')
    return useQuery(inductionProgressQueryOptions(`${hostMode}:${override}`, enabled))
}

export function useStartInduction() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: startInduction,
        onSuccess: (progress) => queryClient.setQueriesData({ queryKey: ['inductionProgress'] }, progress),
    })
}

export function useCompleteInductionStep() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: completeInductionStep,
        onSuccess: (progress) => queryClient.setQueriesData({ queryKey: ['inductionProgress'] }, progress),
    })
}
